import { HttpClient } from '@angular/common/http';
import { Component, ViewChild } from '@angular/core';
import { GoogleMap, MapInfoWindow } from '@angular/google-maps';
import { Observable, map, tap, catchError, of, filter } from 'rxjs';
import { DashboardService } from '../../services/dashboard.service';
import { CidadeOficializada } from '../../models/dashboard.model';

const BR_CENTER: google.maps.LatLngLiteral = { lat: -14.235004, lng: -51.92528 };
const BR_ZOOM = 4;

@Component({
  selector: 'app-officialized-cities',
  templateUrl: './officialized-cities.component.html',
  styleUrls: ['./officialized-cities.component.scss']
})
export class OfficializedCitiesComponent {
  @ViewChild(GoogleMap, { static: false }) map!: GoogleMap;

  apiLoaded!: Observable<boolean>;
  cities: CidadeOficializada[] = [];

  center: google.maps.LatLngLiteral = BR_CENTER;
  zoom = BR_ZOOM;

  // mesmo ícone do inscreva-se
  icon: google.maps.Icon = {
    url: 'assets/icons/google_maps_pin.png',
    scaledSize: { height: 40, width: 40 } as google.maps.Size
  };
  markerOptions: google.maps.MarkerOptions = { draggable: false, icon: this.icon };

  constructor(http: HttpClient, private dashboard: DashboardService) {
    this.apiLoaded = http.jsonp(
      'https://maps.googleapis.com/maps/api/js?key=AIzaSyAV5ZxsqC1kusNs7lnpcfkgBq1ITp0wpto',
      'callback'
    ).pipe(
      map(() => true),
      tap(() => {
        this.dashboard.dashboard
          .pipe(filter((res: any): res is { cidades: CidadeOficializada[] } => !!res?.cidades))
          .subscribe(res => this.cities = res.cidades);
      }),
      catchError(() => of(false)),
    );
  }

  // roda UMA vez após a 1ª renderização do mapa
  onZoomChanged() {
    const z = this.map.getZoom() ?? BR_ZOOM;
    // mesma regra do inscreva-se (ou ajuste como preferir)
    this.icon = {
      url: 'assets/icons/google_maps_pin.png',
      scaledSize: { height: z * 4, width: z * 4 } as google.maps.Size
    };
    this.markerOptions = { ...this.markerOptions, icon: this.icon };
  }
}




